// Детерминированный выбор элемента по строковому seed (градиенты аватаров,
// цвета имён в группах): одинаковый seed → одинаковый выбор между сессиями.
export const pickByHash = <T>(seed: string, options: readonly T[]): T => {
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) | 0;
  }
  return options[Math.abs(hash) % options.length]!;
};
